import { useTranslation } from 'react-i18next';

export default function Experience() {
  const { t } = useTranslation();

  const experiences = [
    {
      year: '2025 - Présent',
      title: 'Sonatel Academy – Plateforme de Gestion des Apprenants',
      manager: 'Birane Baila Wane',
      phone: '',
      linkedin: '',
      description: 'Développement d\'API REST sécurisées avec Laravel et authentification JWT. Gestion des rôles utilisateurs, CI/CD avec GitLab, conteneurisation Docker et orchestration Kubernetes.',
      technologies: ['Laravel', 'PHP', 'MySQL', 'Docker', 'GitLab CI/CD', 'Nginx', 'Kubernetes']
    },
    {
      year: '2024 - 2025',
      title: 'API FOTOL_JAY – Backend de Gestion de Photos',
      manager: 'Aly Tall Niang',
      phone: '77 182 54 14',
      linkedin: 'https://linkedin.com/in/aly-tall-niang-sonatel-academy',
      description: 'Conception d\'API REST avec Express et MongoDB. Gestion des uploads via Cloudinary, pipeline CI/CD avec Jenkins, déploiement sur Kubernetes.',
      technologies: ['Node.js', 'Express', 'MongoDB', 'Jenkins', 'Docker', 'Kubernetes']
    },
    {
      year: '2024',
      title: 'Ges_Paiement_Employeur – API de Gestion des Paiements',
      manager: 'Aly Tall Niang',
      phone: '77 182 54 14',
      linkedin: 'https://linkedin.com/in/aly-tall-niang-sonatel-academy',
      description: 'API REST pour la gestion des employeurs et des paiements. Authentification JWT, transactions sécurisées, automatisation des déploiements.',
      technologies: ['Node.js', 'Express', 'MongoDB', 'Docker', 'GitLab CI/CD']
    },
    {
      year: '2023 - 2024',
      title: 'Sama-BankManager – Backend Bancaire',
      manager: 'Birane Baila Wane',
      phone: '',
      linkedin: '',
      description: 'Développement du backend bancaire (transactions, comptes, rôles utilisateurs). API REST sécurisées, documentation Swagger, tests unitaires.',
      technologies: ['Laravel', 'PHP', 'MySQL', 'Jenkins', 'Docker', 'Kubernetes']
    },
    {
      year: '2023',
      title: 'ProjetMaxit – API de Gestion d\'Entreprise',
      manager: 'Birane Baila Wane',
      phone: '',
      linkedin: '',
      description: 'Backend complet pour la gestion commerciale avec intégration Stripe API, pipeline CI/CD automatisé.',
      technologies: ['Laravel', 'PHP', 'MySQL', 'Stripe API', 'Docker']
    },
    {
      year: '2022 - 2023',
      title: 'API_Restful NodeExpress – Gestion Étudiants',
      manager: '',
      phone: '',
      linkedin: '',
      description: 'API REST avec CRUD complet et middlewares d\'authentification. Intégration continue via GitHub Actions.',
      technologies: ['Node.js', 'Express', 'MongoDB', 'Docker', 'GitHub Actions']
    }
  ];

  return (
    <section id="experience" className="py-24 px-6 bg-[#F5F3EE]">
      <div className="max-w-5xl mx-auto">
        <div className="mb-20">
          <h2 className="text-6xl font-black text-[#0A0A0A] leading-tight">
            {t('experience.title')}<br />{t('experience.subtitle')}
          </h2>
        </div>

        <div className="relative">
          {/* Ligne verticale */}
          <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-gray-300" style={{ borderLeft: '2px dashed #D1D5DB' }}></div>

          <div className="space-y-12">
            {experiences.map((exp, index) => (
              <div key={index} className="relative pl-12">
                {/* Point timeline */}
                <div className="absolute left-0 top-6 w-4 h-4 bg-[#0066FF] rounded-full" style={{ transform: 'translateX(-7px)' }}></div>

                {/* Carte expérience */}
                <div className="bg-white rounded-2xl p-9 shadow-lg hover:shadow-xl transition-all duration-300">
                  <div className="text-sm font-bold text-[#0066FF] mb-3">{exp.year}</div>
                  <h3 className="text-2xl font-bold text-[#0A0A0A] mb-4">{exp.title}</h3>
                  
                  {exp.manager && (
                    <div className="mb-4 space-y-2">
                      <div className="text-sm text-gray-700">
                        <span className="font-medium">Manager:</span> {exp.manager}
                      </div>
                      {exp.phone && (
                        <div className="flex items-center gap-2 text-sm text-gray-600">
                          <i className="ri-phone-line"></i>
                          <span>{exp.phone}</span>
                        </div>
                      )}
                      {exp.linkedin && (
                        <div className="flex items-center gap-2 text-sm">
                          <i className="ri-linkedin-box-fill text-[#0066FF]"></i>
                          <a href={exp.linkedin} target="_blank" rel="noopener noreferrer" className="text-[#0066FF] hover:underline cursor-pointer">
                            LinkedIn
                          </a>
                        </div>
                      )}
                    </div>
                  )}

                  <p className="text-base text-gray-700 leading-relaxed mb-6">
                    {exp.description}
                  </p>

                  <div className="flex flex-wrap gap-2">
                    {exp.technologies.map((tech, idx) => (
                      <span key={idx} className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap">
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
